/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Header_BackInputs */

const es_billing_header_back = /** @type {(inputs: Billing_Header_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al chat`)
};

const en_billing_header_back = /** @type {(inputs: Billing_Header_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to chat`)
};

/**
* | output |
* | --- |
* | "Back to chat" |
*
* @param {Billing_Header_BackInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_header_back = /** @type {((inputs?: Billing_Header_BackInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Header_BackInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_header_back(inputs)
	return en_billing_header_back(inputs)
});
export { billing_header_back as "billing.header.back" }